import React from "react";

interface CustomImageProps
  extends React.ImgHTMLAttributes<HTMLImageElement> {
  radius?: number | string;
}

export const CustomImage: React.FC<CustomImageProps> = ({
  radius = "8px",
  alt = "",
  style,
  ...rest
}) => {
  return (
    <img
      alt={alt}
      {...rest}
      style={{
        borderRadius: radius,
        objectFit: "cover",
        ...style,
      }}
    />
  );
};
